import firebase from "firebase/app";
import "firebase/functions";
import firestore from "src/apiService/firestore";
import { getUserId } from "src/config/storage";
import type { Cookie } from "src/utils/extension";

export async function poshmarkIntegrationCreate(args: {
  cookies: Cookie[];
  integrationId?: string;
  username?: string;
  lastSync?: string;
  bankAccountId?: string | undefined;
  userAgent?: string;
}) {
  const f = firebase.functions().httpsCallable("poshmark-integrationCreate");
  const { userAgent = navigator.userAgent, ...rest } = args;
  return await f({ ...rest, userAgent });
}

export async function poshmarkIntegrationUpdate(args: {
  cookies: Cookie[];
  integrationId?: string;
  userAgent?: string;
}) {
  const f = firebase.functions().httpsCallable("poshmark-integrationUpdate");
  const { userAgent = navigator.userAgent, ...rest } = args;
  return await f({ ...rest, userAgent });
}

export async function poshmarkIntegrationRemoveErrorFlag(id: string) {
  const userId = await getUserId();
  const db = firestore();

  await db.runTransaction(async (transaction) => {
    const ref = db.collection("Plaid_Integrations").doc(id);
    const doc = await transaction.get(ref);
    if (!doc.exists) return;
    if (doc.data()?.user !== userId) return;
    await transaction.update(ref, {
      error: firebase.firestore.FieldValue.delete(),
    });
  });
}

export async function poshmarkIntegrationSyncChange(
  id: string,
  sync: boolean,
  inventory: boolean = true
) {
  const userId = await getUserId();
  const db = firestore();

  await db.runTransaction(async (transaction) => {
    const ref = db.collection("Plaid_Integrations").doc(id);
    const doc = await transaction.get(ref);
    if (!doc.exists) return;
    if (doc.data()?.user !== userId) return;
    await transaction.update(ref, { sync, inventory: sync && inventory });
  });
}

export async function poshmarkIntegrationDelete(id: string): Promise<void> {
  const f = firebase.functions().httpsCallable("poshmark-deleteIntegration");
  await f({ integrationId: id });
}

export async function poshmarkSetDeductionsRemindMeLater(
  integrationId: string,
  deductionsRemindLater: Date
) {
  const db = firestore();
  return await db
    .collection("Plaid_Integrations")
    .doc(integrationId)
    .update({ deductionsRemindLater });
}

export type PoshmarkUploadDeductionReportResponseData =
  | { error: string }
  | { result: { date: string; amount: number | string } };

export async function poshmarkUploadDeductionReport(args: {
  report: string;
}): Promise<PoshmarkUploadDeductionReportResponseData> {
  const f = firebase
    .functions()
    .httpsCallable("poshmark-uploadDeductionReport");
  const result = await f(args);
  return result.data;
}

export async function getPoshmarkIntegration() {
  const uid = await getUserId();
  const db = firestore();
  const integrations = await db
    .collection("Plaid_Integrations")
    .where("user", "==", uid)
    .where("type", "==", "poshmark")
    .get();
  const integration = integrations.docs.pop();
  if (integration) {
    return integration.data();
  } else {
    return null;
  }
}
